<section class="jb-grid sub-grid grid-row-max-content pt5 bt b--light-gray">
  <h3 class="col-5-m col-4-l">{{ title }}</h3>
  <section class="col-5-m col-4-l">
    <ng-content></ng-content>
  </section>
</section>
